.z{width:100%;}